//equalheight

$(function ($) {
$(window).on('load',function() {
equalheight('.about-multicolumn .rte');
equalheight('.about-multicolumn .rte');
});


$(window).on('resize',function() {
equalheight('.about-multicolumn .rte');
equalheight('.about-multicolumn .rte');
});

$(window).on('load',function() {
equalheight('.blog-articles .article-card .card__heading');
equalheight('.blog-articles .article-card .card__heading');
});


$(window).on('resize',function() {
equalheight('.blog-articles .article-card .card__heading');
equalheight('.blog-articles .article-card .card__heading');
});
});


// view more button
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#Huratips-Pagination'
  });
});
 
$('.blog_slider_inner').slick({
  arrows:false,
  dots:true,
  centerMode: true,
  centerPadding: '450px',
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 1650,
      settings: {
        centerPadding: '250px'
      }
    },
    {
      breakpoint: 749,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '100px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});


$('.home_colletion').slick({
  arrows:true,
  dots:false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.slider-single').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: '.slider-nav',
  arrows: false,
  dots: false,
  centerMode: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode:false
      }
    }
  ]
});
 $('.slider-nav').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.slider-single'
});

// $(document).ready(function () {
//   var $grid = $('.meet_the_artists_list').isotope({
//     itemSelector: '.meet_the_artists_block',
//     layoutMode: 'fitRows',
//   });

//   // Filter items on button click
//   // $('.filter-buttons button').on('click', function () {
//   //   var filterValue = $(this).attr('data-filter');
//   //   $grid.isotope({ filter: filterValue });
//   // });

//   $(".filter-buttons button").click(function () {
//       $(".filter-buttons button").removeClass("active");
//       $(this).addClass("active");
//       const filterValue = $(this).attr("data-filter");
//       $grid.isotope({ filter: filterValue });
//   });


// });

// document.addEventListener('DOMContentLoaded', function () {
//   const blocks = document.querySelectorAll('.meet_the_artists_block');
//   const viewMoreBtn = document.getElementById('view-more-btn');
//   const initialVisible = 9;

//   // Hide all blocks after the initialVisible count
//   blocks.forEach((block, index) => {
//     if (index >= initialVisible) {
//       block.classList.add('hidden');
//     }
//   });

//   // Add event listener to the "View More" button
//   viewMoreBtn.addEventListener('click', function () {
//     const hiddenBlocks = document.querySelectorAll('.meet_the_artists_block.hidden');
//     hiddenBlocks.forEach((block, index) => {
//       if (index < initialVisible) {
//         block.classList.remove('hidden');
//       }
//     });

//     // If no more blocks are hidden, hide the button
//     if (hiddenBlocks.length <= initialVisible) {
//       viewMoreBtn.style.display = 'none';
//     }
//   });
  


// });
  document.querySelectorAll('#filterButtons button').forEach(button => {
    button.addEventListener('click', () => {
      const filter = button.getAttribute('data-filter').toUpperCase();
      const blocks = document.querySelectorAll('.filter_block');
      const headings = document.querySelectorAll('.filter-heading');

      blocks.forEach(block => {
        const letter = block.getAttribute('data-letter');
        block.style.display = (filter === 'ALL' || letter === filter) ? 'block' : 'none';
      });

      headings.forEach(heading => {
        const letter = heading.getAttribute('data-heading');
        // Check if there's any visible block for this heading
        const visible = Array.from(document.querySelectorAll(`.filter_block[data-letter="${letter}"]`))
          .some(block => block.style.display === 'block');
        heading.style.display = visible ? 'block' : 'none';
      });
    });
  });
$(document).ready(function () {
      // Initialize Isotope
      var $grid = $('.meet_the_artists_list').isotope({
        itemSelector: '.meet_the_artists_block',
        layoutMode: 'fitRows',
      });

      // Filter items on button click
      $('.filter-buttons button').click(function () {
        var filterValue = $(this).attr('data-filter');
        $grid.isotope({ filter: filterValue });

        // Add active class to the clicked button
        $('.filter-buttons button').removeClass('active');
        $(this).addClass('active');

        // Reset to show only 9 items for the filtered results
        showInitialItems();
      });

      // Initial items to show
      var itemsToShow = 9;
      var $items = $('.meet_the_artists_block');

      function showInitialItems() {
        $items.addClass('hidden'); // Hide all items
        var $visibleItems = $grid.isotope('getFilteredItemElements'); // Get filtered items
        $($visibleItems).slice(0, itemsToShow).removeClass('hidden'); // Show the first 9

        // Hide or show "View More" button based on remaining items
        if ($visibleItems.length > itemsToShow) {
          $('#view-more-btn').show();
        } else {
          $('#view-more-btn').hide();
        }

        // Trigger layout update for Isotope
        $grid.isotope('layout');
      }

      // Show initial items on page load
      showInitialItems();

      // Load more items on button click
      $('#view-more-btn').click(function () {
        itemsToShow += 9;
        var $visibleItems = $grid.isotope('getFilteredItemElements');
        $($visibleItems).slice(0, itemsToShow).removeClass('hidden');

        // Hide "View More" button if no more items to show
        if ($visibleItems.length <= itemsToShow) {
          $('#view-more-btn').hide();
        }

        // Trigger layout update for Isotope
        $grid.isotope('layout');
      });
    });
// Filter show
$(document).ready(function(){
  $("h2.facets__heading").click(function(){
    $(".facets__wrapper").toggleClass("filtershow");
  });
});

document.addEventListener("DOMContentLoaded", function () {
    const description = document.getElementById("productDescription");
    const button = document.getElementById("readMoreBtn");

    if (!description || !button) return;

    // Get line height
    const lineHeight = parseFloat(getComputedStyle(description).lineHeight);

    // Save original height
    const originalHeight = description.scrollHeight;

    // Temporarily limit to 1 line
    description.style.maxHeight = lineHeight + "px";

    // Wait for layout to apply
    requestAnimationFrame(() => {
      if (description.scrollHeight <= lineHeight + 2) {
        // It fits in one line: hide the button
        button.style.display = "none";
      } else {
        // Restore max-height for toggle functionality
        description.style.maxHeight = "";
        button.addEventListener("click", () => {
          description.classList.toggle("more");
          button.textContent = description.classList.contains("more")
            ? "Read less"
            : "Continue reading";
        });
      }
    });
  });





